import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatCurrency } from 'Helpers/UiHelper';

const FlightTypeChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-center text-muted">No data available</p>;
  }

  const spendFormatter = (value) => formatCurrency(value);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="type" />
        <YAxis yAxisId="count" orientation="left" allowDecimals={false} />
        <YAxis yAxisId="spend" orientation="right" tickFormatter={spendFormatter} />
        <Tooltip
          formatter={(value, name) => {
            if (name === 'Total Spend') return [formatCurrency(value), name];
            return [value, name];
          }}
        />
        <Legend />
        <Bar yAxisId="count" dataKey="count" name="Count" fill="#4e73df" />
        <Bar yAxisId="spend" dataKey="totalSpend" name="Total Spend" fill="#1cc88a" />
      </BarChart>
    </ResponsiveContainer>
  );
};

FlightTypeChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      totalSpend: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default FlightTypeChart;
